import React from 'react';
import { useNavigate } from 'react-router-dom';

import { DashboardPendingActionDto, DashboardPendingActionSeverity } from '../../types/types';

interface PendingActionBannerProps {
  action: DashboardPendingActionDto;
}

const SEVERITY_CLASSES: Record<DashboardPendingActionSeverity, { box: string; title: string; button: string }> = {
  INFO: {
    box: 'bg-blue-100',
    title: 'text-blue-700',
    button: 'bg-blue-500 hover:bg-blue-600',
  },
  WARNING: {
    box: 'bg-amber-100',
    title: 'text-amber-800',
    button: 'bg-amber-500 hover:bg-amber-600',
  },
  CRITICAL: {
    box: 'bg-red-100',
    title: 'text-red-700',
    button: 'bg-red-500 hover:bg-red-600',
  },
};

export const PendingActionBanner: React.FC<PendingActionBannerProps> = ({ action }) => {
  const navigate = useNavigate();
  const classes = SEVERITY_CLASSES[action.severity] ?? SEVERITY_CLASSES.INFO;

  return (
    <div className={`flex items-center justify-between gap-3 rounded-2xl px-4 py-3 ${classes.box}`}>
      <div className="min-w-0">
        <p className={`text-sm font-medium ${classes.title}`}>{action.title}</p>
        <p className="text-xs text-slate-600">{action.message}</p>
      </div>
      <button
        type="button"
        onClick={() => navigate(action.ctaLink)}
        className={`shrink-0 rounded-full px-4 py-1.5 text-sm font-medium text-white transition-colors ${classes.button}`}
      >
        {action.ctaText}
      </button>
    </div>
  );
};
